// Template Generated by DataExtraction.py at 1716507313

import OptionalInsuranceEn from "../../Forms/Optional Insurance/OptionalInsurance_En.png";
import OptionalInsuranceEnLabels from "../../Labels/Optional Insurance/OptionalInsurance_En.json";
import OptionalInsuranceFr from "../../Forms/Optional Insurance/OptionalInsurance_Fr.png";
import OptionalInsuranceFrLabels from "../../Labels/Optional Insurance/OptionalInsurance_Fr.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import { PLAN_TYPE_IDS, POSSIBLE_SIGNERS, PROVINCES } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import PlanTypes from "../../../Config/PlanTypes";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? OptionalInsuranceFrLabels : OptionalInsuranceEnLabels;
    const formImage = isFrench ? OptionalInsuranceFr : OptionalInsuranceEn;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;
    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const plan = data.plan;
    const plan2 = data.plan2;

    const sub1Name = subscriber.firstName + (subscriber.lastName ? " " + subscriber.lastName : "");
    const sub2Name = jointSubscriber.firstName + (jointSubscriber.lastName ? " " + jointSubscriber.lastName : "");

    const now = moment();
    const inQuebec = common.signingProvince === "PQ";

    let insuranceJoint = common.subscriber2Include;

    // Drawing the form
    // group insurance
    let groupCriticalIllness = (plan.planTypeID === PLAN_TYPE_IDS.GROUP && plan.criticalIllnessInsurance) || (plan2.planTypeID === PLAN_TYPE_IDS.GROUP && plan2.criticalIllnessInsurance);

    let groupNominee = (plan.planTypeID === PLAN_TYPE_IDS.GROUP && plan.nomineeInsurance) || (plan2.planTypeID === PLAN_TYPE_IDS.GROUP && plan2.nomineeInsurance);
    let groupPaymentProtection = plan.planTypeID === PLAN_TYPE_IDS.GROUP && plan.paymentProtectionInsurance;
    let groupQCCcompletion = (plan.planTypeID === PLAN_TYPE_IDS.GROUP && inQuebec && plan.completionInsurance) || (plan2.planTypeID === PLAN_TYPE_IDS.GROUP && inQuebec && plan2.completionInsurance);

    let anyGroupInsurance = groupCriticalIllness || groupNominee || groupQCCcompletion;

    // achievers insurance
    let achieversCompletion = (plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS && plan.completionInsurance) || (plan2.planTypeID === PLAN_TYPE_IDS.ACHIEVERS && plan2.completionInsurance);
    let achieversCriticalIllness = (plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS && plan.criticalIllnessInsurance) || (plan2.planTypeID === PLAN_TYPE_IDS.ACHIEVERS && plan2.criticalIllnessInsurance);
    let achieversNominee = (plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS && plan.nomineeInsurance) || (plan2.planTypeID === PLAN_TYPE_IDS.ACHIEVERS && plan2.nomineeInsurance);

    let anyAchieversInsurance = achieversCompletion || achieversCriticalIllness || achieversNominee;

    // si insurance
    let siNominee = (plan.planTypeID === PLAN_TYPE_IDS.SI && plan.nomineeInsurance) || (plan2.planTypeID === PLAN_TYPE_IDS.SI && plan2.nomineeInsurance);

    let anySIInsurance = siNominee;

    switch (plan.planTypeID) {
        case PLAN_TYPE_IDS.GROUP:
            fillCheckbox(true, "insuranceGroup");
            break;
        case PLAN_TYPE_IDS.ACHIEVERS:
            fillCheckbox(true, "insuranceAchievers");
            break;
        case PLAN_TYPE_IDS.SI:
            fillCheckbox(true, "insuranceSi");
            break;
    }

    if (anyGroupInsurance) {

        fillCheckbox(groupNominee, "insuranceBenficiaryY");
        fillCheckbox(!groupNominee, "insuranceBenficiaryN");


        if (groupCriticalIllness && !insuranceJoint) {
            fillCheckbox(true, "insuranceCriticalIllnessS1");
        } else if (groupCriticalIllness && insuranceJoint) {
            fillCheckbox(true, "insuranceCriticalIllnessJ");
        } else {
            fillCheckbox(true, "insuranceCriticalIllnessN");
        }
        if (groupQCCcompletion && !insuranceJoint) {
            fillCheckbox(true, "insuranceCompletionS1");
        } else if (groupQCCcompletion && insuranceJoint) {
            fillCheckbox(true, "insuranceCompletionJ");
        } else {
            fillCheckbox(true, "insuranceCompletionN");
        }        
    }


    if (anyAchieversInsurance) {

        if (achieversCompletion && !insuranceJoint) {
            fillCheckbox(true, "insuranceCompletionS1");
        } else if (achieversCompletion && insuranceJoint) {
            fillCheckbox(true, "insuranceCompletionJ");
        } else {
            fillCheckbox(true, "insuranceCompletionN");
        }

        fillCheckbox(!achieversNominee, "insuranceBenficiaryN");
        fillCheckbox(achieversNominee, "insuranceBenficiaryY");

        if (achieversCriticalIllness && !insuranceJoint) {
            fillCheckbox(true, "insuranceCriticalIllnessS1");
        } else if (achieversCriticalIllness && insuranceJoint) {
            fillCheckbox(true, "insuranceCriticalIllnessJ");
        } else {
            fillCheckbox(true, "insuranceCriticalIllnessN");
        }
    }

    if (anySIInsurance) {
        fillCheckbox(!siNominee, "insuranceBenficiaryN");
        fillCheckbox(siNominee, "insuranceBenficiaryY");
    }

    // if no insurance then fill in all the no checkboxes
    if (!anyGroupInsurance && !anyAchieversInsurance && !anySIInsurance) {
        fillCheckbox(true, "insuranceCompletionN");
        fillCheckbox(true, "insuranceBenficiaryN");
        fillCheckbox(true, "insuranceCriticalIllnessN");
    }


    // fillCheckbox(insuranceCriticalIllnessS2, "insuranceCriticalIllnessS2"); // unused
    drawText(common.agentCode, "repCode");
    drawText(common.agentName, "repName");
    drawText(sub1Name, "sub1Name");
    if (common.subscriber2Include) {
        drawText(sub2Name, "sub2Name");
    }
    drawText(now.format("MM-DD-YYYY"), "subscriberSignDate");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? OptionalInsuranceFrLabels : OptionalInsuranceEnLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    const subscriber2Include = state.common.subscriber2Include


    // dealingRepresentativeSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignatureView", labels))],
    });


    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2SignatureView", labels))],
        });
    }

    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1SignatureView", labels))],
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}

